export const environment = {
  auth0: {
    domain: 'dev-ugf5kl55pnf4oaam.eu.auth0.com',
    clientId: 'gsgnPiRLF5YLnlDb6aVlEJG8m13ek0C1',
    authorizationParams: {
      audience: 'pt_designer_api',
      redirect_uri: `${window.origin}/auth-callback`,
    },
    errorPath: '/auth-callback',
  },
  api: {
    serverUrl: 'manager.designer-dev.pharmatrail.io',
    // serverUrl: 'localhost:44344',
  },
  protocol: 'https',
  production: false,
};
